import { all, call, select } from 'redux-saga/effects'
import { AxiosHeaders, RawAxiosRequestHeaders } from 'axios'

import { selectors as AuthSelectors } from '../auth/redux'
import { RestApiResponse, RestRequest } from '../../helpers/RestHelpers'
import RestApiClient from '../../rest/client'

export default class ApiSagas {
  static *rest<Request extends RestRequest>(
    request: Request,
    headers?: RawAxiosRequestHeaders,
    enableBearer = true
  ) {
    const token: string = yield select(AuthSelectors.token)

    const response: RestApiResponse<Request> = yield call(
      RestApiClient.call,
      request,
      {
        ...headers,
        ...(token &&
          enableBearer && {
            Authorization: `Bearer ${token}`,
          }),
      } as AxiosHeaders
    )

    return response
  }

  static *loop() {
    yield all([
      //
    ])
  }
}
